module.exports = __webpack_public_path__ + "media/notification.4a3d0296.mp3";